export default __webpack_public_path__ + "static/media/mo-img-team-advisros-sh3x.a456a164.png";